<template>
    <el-row class="content_wrap">
        <el-row>
            <el-col :span="24"><div class="grid-content bg-purple-dark u_qiaosui_header"><i class="el-icon-s-opportunity"></i>设备异常</div></el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-dark u_suidao_title_c">
                    <div class="grid-content bg-purple u_suidao_table">
                        <el-table :data="abnormalList" max-height="800" border>
                            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                            <el-table-column prop="instrumentName" align="center" label="设备编号" width="150"></el-table-column>
                            <el-table-column prop="dateTime" align="center" label="发生时间" width="150"></el-table-column>
                            <el-table-column prop="mainSystemName" align="center" label="所属系统" width=""></el-table-column>
                            <el-table-column prop="statusName" align="center" label="当前状态" width="">
                                <template slot-scope="scope">
                                    <span style="color:#03B615;" v-if="scope.row.statusName === '正常'">{{scope.row.statusName}}</span>
                                    <span style="color:red;" v-else>{{scope.row.statusName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="technicalScore" align="center" label="是否通知" width=""></el-table-column>
                            <el-table-column prop="technicalScore" align="center" label="通知人" width=""></el-table-column>
                            <el-table-column prop="dateTime" align="center" label="通知时间" width="150"></el-table-column>
                            <el-table-column prop="technicalScore" align="center" label="是否处理" width=""></el-table-column>
                            <el-table-column prop="dateTime" align="center" label="处理时间" width="150"></el-table-column>
                            <el-table-column prop="technicalScore" align="center" label="处理人" width=""></el-table-column>
                            <el-table-column prop="technicalScore" align="center" label="处理结果" width=""></el-table-column>
                            <el-table-column prop="technicalScore" align="center" label="事件原因" width=""></el-table-column>
                            <el-table-column prop="technicalScore" align="center" label="操作" width="80"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-col>
        </el-row>
    </el-row>
</template>

<script>
import $ from 'jquery'
import axios from "axios"
import * as echarts from 'echarts'
import { mapState,mapMutations } from 'vuex'
export default {
    name: 'bridgeAbnormal',
    data() {
        return {
            abnormalList: []
        }
    },
    components: {
    },
    async created() {
        let TunnelId = localStorage.getItem('TunnelId')
        const result = await axios.get(`/bridgetunnel/tunnel/${TunnelId}/status/fault`)
        result.data.forEach(ele => {
            this.abnormalList.push({
                instrumentName: ele.instrumentName,
                dateTime: ele.dateTime.replace('T', ' '),
                mainSystemName: ele.mainSystemName,
                statusName: ele.statusName
            })
        })
    },
    mounted: function () {
    },
    methods: {
        
    },
}
</script>
